export default {
	// The Views, Processes, Activities and Types overviews: the cards (EntityCard and its facts) and
	// the toolbar above them.
	overview: {
		noPreview: "Noch keine Vorschau",
		previewNotSaved: "Die Vorschau konnte nicht gespeichert werden.",
		definedIn: "Definiert in {alias}",
		editInOwnProject: "Im eigenen Projekt bearbeiten",
		noDescription: "Keine Beschreibung",
		noTags: "Keine Tags",
		moreTags: "{count} weitere Tags: {tags}",
		dataobjectsInView: "Datenobjekte in dieser Ansicht",
		dataobjectsInProcess: "Datenobjekte in diesem Prozess",
		moreDataobjects: "{count} weitere",
		noDataobjects: "Noch keine Datenobjekte",
		activityCount: "{count} Aktivität | {count} Aktivitäten",
		noActivities: "Keine Aktivitäten verknüpft",
		actionCount: "{count} Aktion | {count} Aktionen",
		usedIn: "Verwendet in",
		notUsed: "In keinem Prozess verwendet",
		copyCodeName: "Code-Namen kopieren",
		copyLink: "Link kopieren",
		copied: "In die Zwischenablage kopiert",
		copyFailed: "Kopieren in die Zwischenablage fehlgeschlagen",
		// The overviews' ListToolbar: how a list is ordered and narrowed.
		sort: {
			label: "Sortierung",
			name: "Name",
			recent: "Zuletzt geöffnet",
			terminology: "Terminologie",
			dataobjects: "Datenobjekte",
			activities: "Aktivitäten",
			actions: "Aktionen",
			values: "Werte",
			attributes: "Attribute",
			reverseHint: "Erneut klicken, um umzukehren",
			reversed: "umgekehrt",
		},
		filter: {
			tag: "Tag",
			dataobject: "Datenobjekt",
			origin: "Definiert in",
			local: "Dieses Projekt",
			show: "Anzeigen",
			all: "Alle",
			unused: "In keinem Prozess verwendet",
			noActivities: "Ohne Aktivitäten",
			clear: "Filter zurücksetzen",
		},
	},
};
